import { render, staticRenderFns } from "./MediaConversionThumbnail.vue?vue&type=template&id=2255e4fe&scoped=true&"
var script = {}
import style0 from "./MediaConversionThumbnail.vue?vue&type=style&index=0&id=2255e4fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2255e4fe",
  null
  
)

export default component.exports